import moment, { Moment } from 'moment'

import {
  DATE_STORE_KEY_FORMAT,
  DATE_SUBMIT_FORMAT,
} from '../../../Common/settings/dateFormats'

interface IReturnObject {
  startsAt: string
  endsAt: string
  repeatStopsAt: string | null
}

export const blockSpecialDataTransformer = (
  startHour: string,
  endHour: string,
  startsAt: Moment,
  weekInterval: number,
  repeatStopsAfter: number,
  repeatStopsAt: Moment | null,
): IReturnObject => {
  const repeatStopsAtValue: null | string = repeatStopsAt
    ? startsAt
        .clone()
        .add(weekInterval * repeatStopsAfter, 'weeks')
        .format(DATE_STORE_KEY_FORMAT)
    : null

  const splitStartHour: number[] = startHour
    .split(':')
    .map(time => parseInt(time, 10))
  const makeStartsAt: string = moment(startsAt)
    .set({ hour: splitStartHour[0], minutes: splitStartHour[1] })
    .format(DATE_SUBMIT_FORMAT)

  const splitEndHour: number[] = endHour
    .split(':')
    .map(time => parseInt(time, 10))
  const makeEndsAt = moment(startsAt)
    .set({ hour: splitEndHour[0], minutes: splitEndHour[1] })
    .format(DATE_SUBMIT_FORMAT)

  return {
    startsAt: makeStartsAt,
    endsAt: makeEndsAt,
    repeatStopsAt: repeatStopsAtValue,
  }
}
